import { useEffect } from 'react';
import { useTourStore } from '@/state/tour';

export function useReducedMotionSync(): void {
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const apply = () => useTourStore.setState({ reducedMotion: mq.matches });
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);
}
